import { getJson } from "../../auth/utils/getJson.js";
/** GET /api/operators/codes/operatorexportstatus (no params) */
export function fetchExportStatus(signal) {
  return getJson(`/api/operators/codes/operatorexportstatus`, { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}
